import { useContext } from "react"
import styled from "styled-components"
import dynamic from "next/dynamic"
import { color, mq } from "helpers/styled"
import { useLocale } from "react-polyglot-hooks"
import { CarContext } from "../CarContext"

const PlanHeader = dynamic(() => import("./PlanHeader"))
const SoldHeader = dynamic(() => import("./SoldHeader"))
const PlanList = dynamic(() => import("./PlanList"))
const DownPaymentDisclaimer = dynamic(() => import("components/DownPaymentDisclaimer"))
const InfoBanner = dynamic(() => import("components/InfoBanner"))

const Wrapper = styled.div`
  max-width: 410px;
  margin-bottom: 50px;

  @media ${mq("lg")} {
    position: absolute;
    left: 0;
    max-width: none;
    width: 36vw;

    /*
      Exact width to make it meet the edge of the screen
      Note: the scrollbar's width isn't taken into account
    */
    width: calc((100vw - var(--container-width)) / 2 + 100% + var(--grid-gap));
  }

  @media ${mq("xl")} {
    width: 100%;
    max-width: 100%;
  }
`

const Container = styled.div`
  margin-bottom: 15px;
  border-radius: 10px 0 0 10px;
  overflow: hidden;
  box-shadow: 0 2px 6px 0 rgba(195, 205, 224, 0.8);

  @media ${mq("xl")} {
    border-radius: 10px;
  }
`

const Header = styled.div`
  background: ${color("darkBlue")};
  padding: 25px;
`

export default function SideBar() {
  const locale = useLocale()
  const {
    car: { sellingStatus, sold }
  } = useContext(CarContext)

  return (
    <Wrapper>
      <Container>
        <Header>{sold ? <SoldHeader /> : <PlanHeader />}</Header>
        {!sold && <PlanList />}
      </Container>
      {locale === "it" && <DownPaymentDisclaimer />}
      {locale === "es" && sellingStatus === "pre-owned" && (
        <InfoBanner>Solamente se reacondicionan los desperfectos mecánicos y elementos de seguridad</InfoBanner>
      )}
    </Wrapper>
  )
}
